import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-10 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-10 p-sm-15 p-md-20 letter-spacing" }
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger mt-1 fs-md-12"
}
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = {
  key: 0,
  class: "form-control shadow-none fs-md-14 text-black fw-bold",
  readonly: ""
}
const _hoisted_13 = {
  key: 1,
  class: "form-control shadow-none fs-md-14 text-black fw-bold"
}
const _hoisted_14 = {
  key: 2,
  class: "text-danger mt-1 fs-md-12"
}
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "row mb-2" }
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "border border-success mb-5" }
const _hoisted_23 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-1",
  style: {"background-color":"#28a745"}
}
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = {
  class: "fs-15 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "border border-primary mb-5" }
const _hoisted_34 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-1",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = {
  class: "fs-15 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = { class: "border border-danger mb-5" }
const _hoisted_43 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-1",
  style: {"background-color":"#dc3545"}
}
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = {
  class: "fs-15 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { class: "mb-2 mt-1" }
const _hoisted_51 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Fermerture de caisse", -1)),
        _createVNode(_component_router_link, {
          to: "/OuverturesFermetures",
          class: "btn btn-primary transition border-0 lh-1 fw-medium"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
            _createElementVNode("span", { class: "position-relative" }, null, -1),
            _createTextVNode("Retour")
          ])),
          _: 1
        })
      ]),
      _createVNode(_component_Form, {
        class: "row g-2",
        "validation-schema": _ctx.schema,
        onSubmit: _ctx.sendFermerOuvFer
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de fermeture ", -1)),
                _createVNode(_component_Field, {
                  name: "dateFin",
                  type: "datetime-local",
                  max: _ctx.currentDateTime,
                  modelValue: _ctx.dateFin,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateFin) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  readonly: ""
                }, null, 8, ["max", "modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "dateFin",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Personnes présentes à la fermeture "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "user[]" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: _ctx.user,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user) = $event)),
                      options: _ctx.userOptions,
                      searchable: true,
                      multiple: true,
                      taggable: true,
                      mode: "tags",
                      label: "label",
                      "track-by": "value",
                      placeholder: "Sélectionner les personnes"
                    }, field), null, 16, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "user",
                  class: "text-danger"
                }),
                (_ctx.userOptions.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Aucune personne disponible. "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode("Caisse "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              (_ctx.ouvFer.reliquatTotalRetourner > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Vous êtes en train de fermer la caisse : " + _toDisplayString(_ctx.caisseNom) + " avec un montant total reliquat qui est : " + _toDisplayString(_ctx.ouvFer?.reliquatTotalRetourner) + " FCFA ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, " Vous êtes en train de fermer la caisse : " + _toDisplayString(_ctx.caisseNom), 1)),
              (!_ctx.caisseNom)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Aucune caisse ouverte disponible. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[8] || (_cache[8] = _createElementVNode("label", {
                  for: "observationsFin",
                  class: "d-block text-black fw-semibold mb-2"
                }, "Observations", -1)),
                _createVNode(_component_Field, {
                  name: "observationsFin",
                  as: "textarea",
                  class: "form-control fs-md-14",
                  modelValue: _ctx.observationsFin,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.observationsFin) = $event)),
                  placeholder: "Entrez vos observations (facultatif)"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "observationsFin",
                  class: "text-danger fs-md-12"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_ctx.conversionError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.conversionError), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-md-6" }, [
                    _createElementVNode("h3", { class: "fs-15 text-white" }, "Solde Théorique")
                  ], -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("h5", _hoisted_25, " Total : " + _toDisplayString(_ctx.montantTotalTheorique) + " FCFA", 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-1 text-success" }, [
                    _createElementVNode("div", { class: "col-md-4" }, [
                      _createElementVNode("label", { class: "d-block fw-semibold fs-md-13" }, "Monnaie")
                    ]),
                    _createElementVNode("div", { class: "col-md-4" }, [
                      _createElementVNode("label", { class: "d-block fw-semibold fs-md-13" }, "Quantité")
                    ]),
                    _createElementVNode("div", { class: "col-md-4" }, [
                      _createElementVNode("label", { class: "d-block fw-semibold fs-md-13" }, "Montant")
                    ])
                  ], -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("hr", { class: "my-1" }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageTheoriqueList, (billetage, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "container m-1 text-success"
                    }, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            name: "monnaie",
                            placeholder: "Monnaie",
                            "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                            readonly: "",
                            class: "form-control fs-md-13 py-1"
                          }, null, 8, _hoisted_28), [
                            [_vModelText, billetage.libelle]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_Field, {
                            name: `billetageTheoriqueList[${index}].quantite`,
                            type: "number",
                            placeholder: "Quantité",
                            class: "form-control fs-md-13 py-1",
                            modelValue: billetage.quantite,
                            "onUpdate:modelValue": ($event: any) => ((billetage.quantite) = $event),
                            onInput: ($event: any) => (_ctx.handleBilletageTheoriqueInput($event, billetage, index)),
                            readonly: "",
                            min: "0"
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `billetageTheoriqueList[${index}].quantite`,
                            class: "text-danger fs-md-12"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                            placeholder: "Montant",
                            readonly: "",
                            class: "form-control fs-md-13 py-1"
                          }, null, 8, _hoisted_31), [
                            [_vModelText, billetage.montant]
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-6" }, [
                    _createElementVNode("h3", { class: "fs-md-15 text-white" }, "Solde Physique")
                  ], -1)),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("h5", _hoisted_36, " Total : " + _toDisplayString(_ctx.montantTotalReel) + " FCFA", 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-1 text-primary" }, [
                    _createElementVNode("div", { class: "col-md-6" }, [
                      _createElementVNode("label", { class: "d-block fw-semibold fs-md-13" }, "Quantité")
                    ]),
                    _createElementVNode("div", { class: "col-md-6" }, [
                      _createElementVNode("label", { class: "d-block fw-semibold fs-md-13" }, "Montant")
                    ])
                  ], -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "my-1" }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageReelList, (billetage, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "container m-1 text-primary"
                    }, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_Field, {
                            name: `billetageReelList[${index}].quantite`,
                            type: "number",
                            placeholder: `Quantité (${_ctx.billetageTheoriqueList[index]?.libelle})`,
                            class: "form-control fs-md-13 py-1",
                            modelValue: billetage.quantite,
                            "onUpdate:modelValue": ($event: any) => ((billetage.quantite) = $event),
                            onInput: ($event: any) => (_ctx.handleBilletageReelInput($event, billetage, index)),
                            min: "0"
                          }, null, 8, ["name", "placeholder", "modelValue", "onUpdate:modelValue", "onInput"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `billetageReelList[${index}].quantite`,
                            class: "text-danger fs-md-12"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                            placeholder: "Montant",
                            readonly: "",
                            class: "form-control fs-md-13 py-1"
                          }, null, 8, _hoisted_40), [
                            [_vModelText, billetage.montant]
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-md-6" }, [
                    _createElementVNode("h3", { class: "fs-15 text-white" }, "Écart")
                  ], -1)),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("h5", _hoisted_45, " Total : " + _toDisplayString(_ctx.montantTotalEcart) + " FCFA", 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-1 text-danger" }, [
                    _createElementVNode("div", { class: "col-md-6" }, [
                      _createElementVNode("label", { class: "d-block fw-semibold fs-md-13" }, "Quantité")
                    ]),
                    _createElementVNode("div", { class: "col-md-6" }, [
                      _createElementVNode("label", { class: "d-block fw-semibold fs-md-13" }, "Montant")
                    ])
                  ], -1)),
                  _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "my-1" }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ecartList, (billetage, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "container m-1 text-danger"
                    }, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_Field, {
                            name: `ecartList[${index}].quantite`,
                            type: "number",
                            modelValue: billetage.quantite,
                            "onUpdate:modelValue": ($event: any) => ((billetage.quantite) = $event),
                            placeholder: `Quantité (${_ctx.billetageTheoriqueList[index]?.libelle})`,
                            readonly: "",
                            class: "form-control fs-md-13 py-1"
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "placeholder"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `ecartList[${index}].quantite`,
                            class: "text-danger fs-md-12"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                            placeholder: "Montant",
                            readonly: "",
                            class: "form-control fs-md-13 py-1"
                          }, null, 8, _hoisted_49), [
                            [_vModelText, billetage.montant]
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary btn-sm top-end",
              disabled: !_ctx.caisse || _ctx.conversionError
            }, " Fermer ", 8, _hoisted_51),
            _createVNode(_component_router_link, {
              to: "/OuverturesFermetures",
              type: "button",
              class: "btn btn-danger btn-sm mx-1"
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createTextVNode(" Annuler ")
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["validation-schema", "onSubmit"])
    ])
  ]))
}